import WidgetTypeCard, { Props as ImportedProps } from './WidgetTypeCard';
import WidgetTypeCardContainer from './WidgetTypeCard.container';

export default WidgetTypeCardContainer(WidgetTypeCard);
export type Props = ImportedProps;
